<script setup lang="ts">
import EditDsDataAuthVODrawer from '@/pages/erp/ds/auth/view/ds-dataAuth-drawer.vue'
import type { DsDataAuthVOProperties } from '@/pages/erp/ds/auth/db/ds-dataAuth-types'
import Swal from 'sweetalert2'
definePage({
    meta: {
        action: 'manage',
        subject: 'DSDATAAUTH',
    },
})

const compId = ref(useStorage('compNo').value)
const infoId = ref()
const voId = ref()
const authDesc = ref()

// Data table options
const currentPage = ref(1)
const size = ref(10)
const sortOrder = ref()
const orderByCol = ref()

// Update data table options
const updateOptions = (options: any) => {
  sortOrder.value = options.sortBy[0]?.key
  orderByCol.value = options.sortBy[0]?.order
}

// Headers

const grid1Headers = [
    { title: '資訊代碼', key: 'infoId' },
    { title: '授權範圍', key: 'authScope' },
    { title: '授權說明', key: 'authDesc' },
    { title: '操作', key: 'actions', sortable: false}
]


// champ 後端分頁是從 0 開始
const page = computed((): number => currentPage.value - 1)

// 👉 Fetching users
const { data: dsDataAuthVOsData, execute: fetchDsDataAuthVOs } = await useApi<any>(createUrl('/ds/auth/dataAuth/searchDsDataAuthVO', {
  query: {
    compId,
    infoId,
    voId,
    authDesc,
    page,
    size,
    orderByCol,
    sortOrder,
  },
}))

const datas = computed((): DsDataAuthVOProperties[] => dsDataAuthVOsData.value.data.dsDataAuthVOPage.content)
const totalDatas = computed(() => dsDataAuthVOsData.value.data.dsDataAuthVOPage.totalElements)

console.log('datas: ', datas)

const isEditDataDrawerVisible = ref(false)
const isNewData = ref(false)
const isCopyData = ref(false)

let voData = {}


const createData = () => {
  isEditDataDrawerVisible.value = true
  isNewData.value = true
  isCopyData.value = false
}

const editData = (dsDataAuthVOData: DsDataAuthVOProperties) => {
  voData = dsDataAuthVOData
  console.log('editDsDataAuthVO: ', voData)
  isEditDataDrawerVisible.value = true
  isNewData.value = false
  isCopyData.value = false
}

const copyData = (dsDataAuthVOData: DsDataAuthVOProperties) => {
    voData = dsDataAuthVOData
    console.log('copyDsDataAuthVO: ', voData)
    isEditDataDrawerVisible.value = true
    isNewData.value = true
    isCopyData.value = true
}

// 👉 Add new data
const addNewData = async (dsDataAuthVOData: DsDataAuthVOProperties) => {
  await $api('/ds/auth/dataAuth/createDsDataAuthVO', {
    method: 'POST',
    body: { dsDataAuthVO: dsDataAuthVOData },
  }).then(() => {
      $swal({
      position: 'top-end',
      icon: 'success',
      title: '新增成功',
      showConfirmButton: false,
      timer: 1500,
      customClass: {
        confirmButton: 'btn btn-primary',
      },
      buttonsStyling: false,
    })
  })

  // refetch data
  fetchDsDataAuthVOs()
}

const updateData = async (dsDataAuthVOData: DsDataAuthVOProperties) => {
  await $api('/ds/auth/dataAuth/updateDsDataAuthVO', {
    method: 'PUT',
    body: { dsDataAuthVO: dsDataAuthVOData },
  }).then(() => {
      $swal({
      position: 'top-end',
      icon: 'success',
      title: '修改成功',
      showConfirmButton: false,
      timer: 1500,
      customClass: {
        confirmButton: 'btn btn-primary',
      },
      buttonsStyling: false,
    })
  })

  // refetch data
  fetchDsDataAuthVOs()
}

  // 👉 Delete data
const deleteData = async (dsDataAuthVOData: DsDataAuthVOProperties) => {
  const { compId,infoId,voId,columnName } = dsDataAuthVOData
    $swal({
    title: `確定要刪除 ${dsDataAuthVOData.infoId} 資料?`,
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: "確定",
    cancelButtonText: "取消",
    reverseButtons: true
  }).then((result) => {
    if (result.isConfirmed) {
        $api(`/ds/auth/dataAuth/deleteDsDataAuthVO`, {
        method: 'DELETE',
        query: {
          compId,infoId,voId,columnName
        }
      }).then(() => {
          $swal({
          position: 'top-end',
          title: "刪除成功",
          timer: 1500,
          icon: "success"
        });

        // refetch Data
        fetchDsDataAuthVOs()
      })
    }
  });

}

const clickRow = (event, select) => {
  console.log('clickRow: ', event, select)
  editData(select.item)
}

</script>

<template>
  <!-- 👉 Widgets -->

  <VCard class="mb-6">
    <VCardItem class="pb-2 pt-2">
      <VCardTitle>搜尋</VCardTitle>
    </VCardItem>

    <VCardText>
      <VRow>
        <VCol
         cols="12"
         sm="2"
        >
          <AppTextField
            v-model="compId"
            clearable
            clear-icon="mdi-close-circle"
            placeholder="請輸入公司別"
          />
        </VCol>
        <VCol
         cols="12"
         sm="2"
        >
          <AppTextField
            v-model="infoId"
            clearable
            clear-icon="mdi-close-circle"
            placeholder="請輸入資訊代碼"
          />
        </VCol>
        <VCol
         cols="12"
         sm="2"
        >
          <AppTextField
            v-model="voId"
            clearable
            clear-icon="mdi-close-circle"
            placeholder="請輸入VO名稱"
          />
        </VCol>
        <VCol
         cols="12"
         sm="2"
        >
          <AppTextField
            v-model="authDesc"
            clearable
            clear-icon="mdi-close-circle"
            placeholder="請輸入授權說明"
          />
        </VCol>
      </VRow>
    </VCardText>

    <VDivider />

    <VCardText class="d-flex flex-wrap gap-4">
      <VSpacer />

      <div class="app-user-search-filter d-flex align-center flex-wrap gap-4">
        <!-- 👉 Add button -->
        <VBtn
                prepend-icon="tabler-plus"
                @click="createData"
        >
          新增資料授權管理
        </VBtn>
      </div>
    </VCardText>

    <VDivider />

    <!-- SECTION datatable -->
    <VDataTableServer
            v-model:items-per-page="size"
            v-model:page="currentPage"
            :items="datas"
            :items-length="totalDatas"
            :headers="grid1Headers"
            class="text-no-wrap"
            @update:options="updateOptions"
    >

      <template #item.infoId="{ item }">
          <div class="text-body-1 text-high-emphasis">
              {{ item.infoId }}
          </div>
      </template>

      <template #item.authScope="{ item }">
          <div class="text-body-1 text-high-emphasis">
              {{ item.authScope }}
          </div>
      </template>

      <template #item.authDesc="{ item }">
          <div class="text-body-1 text-high-emphasis">
              {{ item.authDesc }}
          </div>
      </template>

      <!-- Actions -->
      <template #item.actions="{ item }">
          <IconBtn @click="editData(item)">
              <VIcon icon="tabler-edit" />
              <v-tooltip
                      activator="parent"
                      location="bottom"
              >編輯</v-tooltip>
          </IconBtn>
          <IconBtn @click="copyData(item)">
              <VIcon icon="tabler-copy" />
              <v-tooltip
                      activator="parent"
                      location="bottom"
              >複製</v-tooltip>
          </IconBtn>
          <IconBtn @click="deleteData(item)">
              <VIcon icon="tabler-trash" />
              <v-tooltip
                      activator="parent"
                      location="bottom"
              >刪除</v-tooltip>
          </IconBtn>
      </template>

      <!-- pagination -->
      <template #bottom>
        <TablePagination
                v-model:page="currentPage"
                v-model:size="size"
                :items-per-page="size"
                :total-items="totalDatas"
        />
      </template>
    </VDataTableServer>
    <!-- SECTION -->
  </VCard>
  <!-- 👉 Edit -->
  <EditDsDataAuthVODrawer
          v-model:isDrawerOpen="isEditDataDrawerVisible"
          :dsDataAuthVO-data="voData"
          :is-new="isNewData"
          :is-copy="isCopyData"
          @create-data="addNewData"
          @update-data="updateData"
  />

</template>
